var _rect, _rect2, _g, _rect3, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 46.7,
    height: 46.7,
    rx: 4.35,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 46.7,
    height: 46.7,
    rx: 4.35,
    stroke: "#DBDEE1",
    strokeWidth: 1.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter0_f_4462_27517)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.5918,
    y: 24,
    width: 28.0945,
    height: 17.5591,
    rx: 8.77954,
    fill: "url(#paint0_linear_4462_27517)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.74023,
    y: 8.74219,
    width: 30.4357,
    height: 30.4357,
    rx: 12.3724,
    fill: "url(#paint1_linear_4462_27517)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4462_27517)",
    filter: "url(#filter1_i_4462_27517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5137 33.0742L15.844 28.1276C14.7711 26.2007 14.4303 23.9521 14.884 21.7945C15.3377 19.6369 16.5555 17.715 18.314 16.3815C20.0726 15.048 22.2538 14.3923 24.4575 14.5348C26.6611 14.6772 28.7394 15.6083 30.311 17.1571C31.8826 18.7059 32.842 20.7685 33.0132 22.9665C33.1844 25.1645 32.5559 27.3504 31.243 29.1231C29.9302 30.8958 28.021 32.1364 25.8659 32.6173C23.7107 33.0981 21.4542 32.7869 19.5104 31.7408L14.5137 33.0742ZM19.7513 29.8898L20.0603 30.0728C21.4683 30.906 23.1128 31.2507 24.7375 31.0534C26.3623 30.8561 27.876 30.1277 29.0428 28.9818C30.2096 27.8359 30.964 26.3369 31.1883 24.7183C31.4127 23.0997 31.0944 21.4525 30.2831 20.0333C29.4718 18.6142 28.2131 17.5028 26.7031 16.8724C25.193 16.2421 23.5166 16.1281 21.9349 16.5482C20.3532 16.9684 18.9551 17.8991 17.9586 19.1953C16.962 20.4915 16.423 22.0804 16.4254 23.7144C16.4241 25.0693 16.7994 26.3979 17.5096 27.5525L17.7034 27.8714L16.9596 30.6323L19.7513 29.8898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2515 24.9855C27.0704 24.8396 26.8583 24.737 26.6314 24.6853C26.4045 24.6337 26.1687 24.6344 25.9421 24.6875C25.6017 24.8286 25.3817 25.362 25.1617 25.6287C25.1154 25.6926 25.0472 25.7374 24.97 25.7548C24.8929 25.7721 24.8121 25.7607 24.7427 25.7228C23.4964 25.2354 22.4516 24.3417 21.7782 23.1868C21.7208 23.1147 21.6936 23.0232 21.7024 22.9315C21.7112 22.8398 21.7553 22.7551 21.8254 22.6952C22.0707 22.4528 22.2509 22.1524 22.3491 21.822C22.371 21.4576 22.2873 21.0945 22.1082 20.7762C21.9697 20.33 21.7062 19.9326 21.3488 19.6311C21.1644 19.5483 20.96 19.5206 20.7602 19.5512C20.5604 19.5818 20.3737 19.6695 20.2227 19.8036C19.9605 20.0295 19.7524 20.3111 19.6137 20.6278C19.4751 20.9446 19.4093 21.2883 19.4213 21.6338C19.4221 21.8278 19.4468 22.0209 19.4946 22.209C19.6163 22.6607 19.8033 23.0923 20.0498 23.49C20.2277 23.7947 20.4218 24.0897 20.6312 24.3737C21.3119 25.3066 22.1675 26.0986 23.1505 26.7058C23.6438 27.0144 24.171 27.2653 24.7218 27.4536C25.2939 27.7125 25.9256 27.8119 26.5497 27.7412C26.9053 27.6874 27.2423 27.5473 27.5309 27.333C27.8195 27.1187 28.0509 26.8369 28.2048 26.5124C28.2952 26.3163 28.3227 26.0971 28.2834 25.8849C28.1891 25.4509 27.6077 25.1947 27.2515 24.9855Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4462_27517",
    x: 4.1318,
    y: 18.54,
    width: 39.0138,
    height: 28.4786,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.73,
    result: "effect1_foregroundBlur_4462_27517"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4462_27517",
    x: 14.5137,
    y: 14.5156,
    width: 18.5586,
    height: 18.7648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.206207
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.515516
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4462_27517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4462_27517",
    x1: 25.5807,
    y1: 42.0827,
    x2: 19.8541,
    y2: 21.8985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07FF74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4462_27517",
    x1: 26.0616,
    y1: 40.0856,
    x2: 11.8333,
    y2: 8.74219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07FF74"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4462_27517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.5586,
    height: 18.5586,
    fill: "white",
    transform: "translate(14.5137 14.5156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsImg);
export default __webpack_public_path__ + "static/media/whats-img.daa886292ec7ceb540f68b1b58e359d5.svg";
export { ForwardRef as ReactComponent };